module.exports = __webpack_public_path__ + "static/education_pic-d8146d955b1ef3d2216a6af9eb02b1d3.png";